(() => {
  const GLOBAL_KEY = '__mtBlackFridayCountdown';
  const SECTION_SELECTOR = '[data-mt-blackfriday-countdown]';

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initAll(document);
    return;
  }

  const timers = new WeakMap();

  const findSections = (container = document) => {
    const sections = [];

    if (container?.matches?.(SECTION_SELECTOR)) {
      sections.push(container);
    }

    container?.querySelectorAll?.(SECTION_SELECTOR).forEach((section) => sections.push(section));
    return sections;
  };

  const parseTargetDate = (value) => {
    const raw = String(value || '').trim();
    if (!raw || !/(?:Z|[+-]\d{2}:\d{2})$/i.test(raw)) return null;

    const target = new Date(raw);
    return Number.isNaN(target.getTime()) ? null : target;
  };

  const formatNumber = (value) => String(Math.max(0, Number(value) || 0)).padStart(2, '0');

  const setNumber = (element, value) => {
    if (!element) return;

    const formatted = formatNumber(value);
    element.textContent = formatted;
    element.dataset.digits = String(formatted.length);
  };

  const clearTimer = (section) => {
    const intervalId = timers.get(section);
    if (intervalId) clearInterval(intervalId);
    timers.delete(section);
  };

  const setAllNumbers = (parts, values) => {
    setNumber(parts.days, values.days);
    setNumber(parts.hours, values.hours);
    setNumber(parts.minutes, values.minutes);
    setNumber(parts.seconds, values.seconds);
  };

  const setTerminalState = (section, state, message) => {
    section.dataset.countdownState = state;

    const visibleStatus = section.querySelector('[data-countdown-visible-status]');
    const liveStatus = section.querySelector('[data-countdown-live-status]');
    const timer = section.querySelector('[data-countdown-timer]');

    if (visibleStatus) {
      visibleStatus.textContent = message || '';
      visibleStatus.hidden = !message;
    }

    if (liveStatus) liveStatus.textContent = message || '';
    if (timer && message) timer.setAttribute('aria-label', message);
  };

  const initSection = (section) => {
    if (!section || section.dataset.countdownInitialized === 'true') return;
    section.dataset.countdownInitialized = 'true';

    const targetDate = parseTargetDate(section.dataset.targetDatetime);
    const heading = section.querySelector('[data-countdown-heading]');
    const timer = section.querySelector('[data-countdown-timer]');
    const parts = {
      days: section.querySelector('[data-countdown-part="days"]'),
      hours: section.querySelector('[data-countdown-part="hours"]'),
      minutes: section.querySelector('[data-countdown-part="minutes"]'),
      seconds: section.querySelector('[data-countdown-part="seconds"]'),
    };

    if (!targetDate) {
      setAllNumbers(parts, { days: 0, hours: 0, minutes: 0, seconds: 0 });
      setTerminalState(section, 'invalid', section.dataset.invalidStatus || '');
      return;
    }

    const update = () => {
      const remaining = targetDate.getTime() - Date.now();

      if (remaining <= 0) {
        setAllNumbers(parts, { days: 0, hours: 0, minutes: 0, seconds: 0 });

        if (heading && section.dataset.expiredTitle) {
          heading.textContent = section.dataset.expiredTitle;
        }

        setTerminalState(section, 'expired', section.dataset.expiredStatus || '');
        clearTimer(section);
        return;
      }

      const totalSeconds = Math.ceil(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
      };

      section.dataset.countdownState = 'active';
      setAllNumbers(parts, values);

      if (timer) {
        timer.setAttribute(
          'aria-label',
          `${values.days} days, ${values.hours} hours, ${values.minutes} minutes remaining`,
        );
      }
    };

    update();

    if (section.dataset.countdownState === 'active') {
      timers.set(section, window.setInterval(update, 1000));
    }
  };

  const initAll = (container = document) => {
    findSections(container).forEach(initSection);
  };

  const api = { initAll };
  window[GLOBAL_KEY] = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    findSections(event.target).forEach(clearTimer);
  });
})();
